import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {bindActionCreators} from 'redux';
import * as selectors from '../sample.selectors';
import * as sampleActions from '../sample.actions';
import * as applicationActions from '../../../application.actions';
import {FileUploader, PageSection, WarningButton, autoRefreshCellRenderer, DangerButton, DefaultButton, Modal} from '../../../components'
import {NursingFacilityNotifier, SampleDataGrid} from "../components";
import Filters from "../components/Filters";
import ClearSampleButton from "../components/ClearSampleButton";

const Container = styled.div`
`;

const StyledPageSection = styled(PageSection)`
  margin-bottom: 2rem;
`;

class SampleContainer extends React.Component {

  state = {showModal: false, patientId: '', patientName: ''};
  
  showModal = (patientId, patientName) => () => this.setState(({showModal: true, patientId, patientName}));
  hideModal = () => this.setState(({showModal: false}));

  onPatientRemoved = (patientId) => () => {
    this.props.actions.removePatient(patientId);
    this.hideModal();
  };

  onPatientRestored = (patientId) => () => this.props.actions.restorePatient(patientId);
  uploadSampleData = period => file => this.props.actions.uploadSampleData(period.id, file);
  onNotifyNursingFacilities = (period) => () => this.props.actions.notifyNursingFacilities(period.id);


  samplePatientActions = ({data: {id, name}, colDef: {enabled}}) => (
    <div>
      <WarningButton className="btn-sm" disabled={!enabled} onClick={this.showModal(id, name)}>Remove</WarningButton>
    </div>
  );

  removedPatientActions = ({data: {id}, colDef: {enabled}}) => (
    <div>
      <WarningButton className="btn-sm" disabled={!enabled} onClick={this.onPatientRestored(id)}>Restore</WarningButton>
    </div>
  );

  renderModal() {
    const {showModal, patientId, patientName} = this.state;

    return (
      <Modal
        show={showModal}
        title="Delete Patient"
        onClose={this.hideModal}
        body={<div>Are you sure you want to delete {patientName}?</div>}
        footer={
          <React.Fragment>
            <DefaultButton onClick={this.hideModal}>Cancel</DefaultButton>
            <WarningButton onClick={this.onPatientRemoved(patientId)}>Yes</WarningButton>
          </React.Fragment>
        }
      />
    )
  }

  render() {
    const {
      facilities,
      period,
      patients,
      removedPatients,
      notifyingNursingFacilities
    } = this.props;

    return (
      <Container>

        {period.quarterlyStatusValue < 2 && (
          <StyledPageSection title="Upload PASRR Review Sample">
            <FileUploader
              fileTypes={['xls', 'xlsx']}
              onUpload={this.uploadSampleData(period)}
            />
          </StyledPageSection>
        )}

        <a onClick={this.props.actions.downloadSampleTemplate} href="/CR Sample Template.xlsx">
          Click here to download "CRSample Template.xlsx"
        </a>

        <StyledPageSection title="Finalize PASRR Review Sample">
          <Filters
            filters={this.props.filters}
            facilities={facilities}
            search={this.props.actions.setFilters}
            clear={this.props.actions.clearFilters}
          >
            <ClearSampleButton
              disabled={!patients.length}
              deleteSampleData={this.props.actions.deleteSampleData}
            />
          </Filters>

          <SampleDataGrid
            height={596}
            pageSize={300}
            patients={patients}
            actionsRenderer={autoRefreshCellRenderer(this.samplePatientActions)}
          />
          {period.quarterlyStatusValue < 2 && Boolean(period.dueDate) && (
            <NursingFacilityNotifier
              disabled={patients.length === 0}
              busy={notifyingNursingFacilities}
              onClick={this.onNotifyNursingFacilities(period)}
            />
          )}
        </StyledPageSection>

        <StyledPageSection title="Removed Patients">
          <SampleDataGrid
            height={247}
            pageSize={300}
            patients={removedPatients}
            actionsRenderer={autoRefreshCellRenderer(this.removedPatientActions)}
          />
        </StyledPageSection>

        {this.renderModal()}
      </Container>
    );
  }
}

export default connect(
  (state) => ({
    filters: selectors.filters(state),
    period: selectors.currentPeriod(state),
    facilities: selectors.facilities(state),
    patients: selectors.includedPatients(state),
    removedPatients: selectors.removedPatients(state),
    notifyingNursingFacilities: state.sample.notifyingNursingFacilities
  }),
  dispatch => ({
    actions: bindActionCreators({
      ...applicationActions,
      ...sampleActions
    }, dispatch)
  })
)(SampleContainer);



// WEBPACK FOOTER //
// ./src/modules/sample/admin/SampleContainer.js